import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import './ProductsOverview.css';
import groceries from '../../assets/groceries.jpg'; // Adjusted spelling
import beverages from '../../assets/beverages.jpg';
import household from '../../assets/household.jpg';
import snacks from '../../assets/snacks.jpg';
import frozen from '../../assets/frozen.jpg';

const ProductsOverview = () => {
  const carouselRef = useRef(null);

  const scrollLeft = () => {
    carouselRef.current.scrollBy({ left: -340, behavior: 'smooth' });
  };

  const scrollRight = () => {
    carouselRef.current.scrollBy({ left: 340, behavior: 'smooth' });
  };

  const categories = [
    {
      title: 'Groceries',
      text: 'Bulk staples like pasta and canned veg - stock up cheap!',
      image: groceries,
      savings: 'Up to 30%',
      stock: '500+ Packs',
    },
    {
      title: 'Beverages',
      text: 'Cases of juice and coffee for your trade - sorted!',
      image: beverages,
      savings: 'Up to 25%',
      stock: '300+ Cases',
    },
    {
      title: 'Household Goods',
      text: 'Bulk detergents and tissues - value you can’t beat!',
      image: household,
      savings: 'Up to 35%',
      stock: '400+ Units',
    },
    {
      title: 'Snacks & Treats',
      text: 'Chocs, nuts, and crisps in bulk - smashing deals!',
      image: snacks,
      savings: 'Up to 20%',
      stock: '600+ Boxes',
    },
    {
      title: 'Frozen Foods',
      text: 'Burgers, fries, and more - fill your freezers fast!',
      image: frozen,
      savings: 'Up to 28%',
      stock: '350+ Packs',
    },
    {
      title: 'Personal Care',
      text: 'Bulk soaps and deodorants - savings that shine!',
      image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60',
      savings: 'Up to 32%',
      stock: '450+ Units',
    },
  ];

  return (
    <section id="products" className="products-overview">
      <motion.h2
        className="products-title"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
        viewport={{ once: true }}
      >
        Bulk Bargains Highlights
      </motion.h2>
      <div className="carousel-nav">
        <button className="nav-btn" onClick={scrollLeft}>←</button>
        <button className="nav-btn" onClick={scrollRight}>→</button>
      </div>
      <div className="products-carousel" ref={carouselRef}>
        {categories.map((category, index) => (
          <motion.div
            key={index}
            className="product-card"
            initial={{ opacity: 0, x: index % 2 === 0 ? -100 : 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, delay: index * 0.2, ease: 'easeOut' }}
            whileHover={{ scale: 1.05, rotate: 1 }}
            viewport={{ once: true }}
          >
            <img src={category.image} alt={category.title} className="product-image" />
            <div className="product-content">
              <h3 className="product-card-title">{category.title}</h3>
              <p className="product-card-text">{category.text}</p>
              <div className="product-stats">
                <motion.span
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ duration: 1, delay: 0.5 }}
                >
                  Savings: {category.savings}
                </motion.span>
                <motion.span
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  transition={{ duration: 1, delay: 0.7 }}
                >
                  Stock: {category.stock}
                </motion.span>
              </div>
              <a href={`#${category.title.toLowerCase().replace(' & ', '-')}`} className="product-card-link">
                Discover Offers
              </a>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default ProductsOverview;